import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/ScrollTop';

const AppLayout = () => {
  const { pathname } = useLocation();
  const hideSiteChrome =
    pathname === '/apply-loan' ||
    pathname.startsWith('/apply-loan/') ||
    pathname === '/apply-now' ||
    pathname.startsWith('/apply-now/');

  return (
    <>
      <ScrollTop />
      <ScrollToTopButton />
      {!hideSiteChrome && <Header />}
      {!hideSiteChrome && <Navbar />}
      <AppRoutes />
      {!hideSiteChrome && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
};

export default App;
